import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'panel-cumplimiento',
  templateUrl: './panel-cumplimiento.component.html',
  styleUrls: ['./panel-cumplimiento.component.css'],
})
export class PanelDeCumplimientoComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private router: Router
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    //this.authService.isAuthenticated();
    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    const childKey = this.router.url.includes(
      '/InformationProtection/ContinuousImprovement'
    )
      ? 'menu.administration.continuousImprovement'
      : 'menu.administration.dpoComplianceDashboard';

    this.selectedNavItem({
      parent: 'microsoftPurview.microsoftPurview',
      child: childKey,
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
